import AdminTestPlanState from './state';
import { AdminTestPlanTypes } from './types';

const INITIAL_STATE = new AdminTestPlanState();

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //-------------------------------------------------
    // GET_ADMIN_TEST_PLAN_LIST
    case AdminTestPlanTypes.GET_ADMIN_TEST_PLAN_LIST.LOADING:
      return {
        ...state,
        adminTestPlanList: {
          ...state.adminTestPlanList,
          loading: true,
          error: null,
        },
      };
    case AdminTestPlanTypes.GET_ADMIN_TEST_PLAN_LIST.SUCCESS:
      return {
        ...state,
        adminTestPlanList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestPlanTypes.GET_ADMIN_TEST_PLAN_LIST.ERROR:
      return {
        ...state,
        adminTestPlanList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    // GET_ADMIN_ARCHIVED_TEST_PLAN_LIST
    case AdminTestPlanTypes.GET_ADMIN_ARCHIVED_TEST_PLAN_LIST.LOADING:
      return {
        ...state,
        adminArchivedTestPlanList: {
          ...state.adminArchivedTestPlanList,
          loading: true,
          error: null,
        },
      };
    case AdminTestPlanTypes.GET_ADMIN_ARCHIVED_TEST_PLAN_LIST.SUCCESS:
      return {
        ...state,
        adminArchivedTestPlanList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestPlanTypes.GET_ADMIN_ARCHIVED_TEST_PLAN_LIST.ERROR:
      return {
        ...state,
        adminArchivedTestPlanList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    // GET_ADMIN_DRAFT_TEST_PLAN_LIST
    case AdminTestPlanTypes.GET_ADMIN_DRAFT_TEST_PLAN_LIST.LOADING:
      return {
        ...state,
        adminDraftTestPlanList: {
          ...state.adminDraftTestPlanList,
          loading: true,
          error: null,
        },
      };
    case AdminTestPlanTypes.GET_ADMIN_DRAFT_TEST_PLAN_LIST.SUCCESS:
      return {
        ...state,
        adminDraftTestPlanList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestPlanTypes.GET_ADMIN_DRAFT_TEST_PLAN_LIST.ERROR:
      return {
        ...state,
        adminDraftTestPlanList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_ADMIN_TEST_PLAN_DETAIL
    case AdminTestPlanTypes.GET_ADMIN_TEST_PLAN_DETAIL.LOADING:
      return {
        ...state,
        adminTestPlan: {
          loading: true,
          data: {
            ...(action.keepPrevious ? (state.adminTestPlan?.data || {}) : {})
          },
          error: null,
        },
      };
    case AdminTestPlanTypes.GET_ADMIN_TEST_PLAN_DETAIL.SUCCESS:
      return {
        ...state,
        adminTestPlan: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestPlanTypes.GET_ADMIN_TEST_PLAN_DETAIL.ERROR:
      return {
        ...state,
        adminTestPlan: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    // GET_ADMIN_TEST_PLAN_TAGS
    case AdminTestPlanTypes.GET_ADMIN_TEST_PLAN_TAGS.LOADING:
      return {
        ...state,
        adminTestPlanTags: {
          ...state.adminTestPlanTags,
          loading: true,
        },
      };
    case AdminTestPlanTypes.GET_ADMIN_TEST_PLAN_TAGS.SUCCESS:
      return {
        ...state,
        adminTestPlanTags: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestPlanTypes.GET_ADMIN_TEST_PLAN_TAGS.ERROR:
      return {
        ...state,
        adminTestPlanTags: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // CREATE_ADMIN_TEST_PLAN_DETAIL
    case AdminTestPlanTypes.CREATE_ADMIN_TEST_PLAN_DETAIL.LOADING:
      return {
        ...state,
        adminTestPlan: {
          loading: true,
          data: {},
          error: null,
        },
      };
    case AdminTestPlanTypes.CREATE_ADMIN_TEST_PLAN_DETAIL.SUCCESS:
      return {
        ...state,
        adminTestPlan: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestPlanTypes.CREATE_ADMIN_TEST_PLAN_DETAIL.ERROR:
      return {
        ...state,
        adminTestPlan: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // UPDATE_ADMIN_TEST_PLAN_DETAIL
    case AdminTestPlanTypes.UPDATE_ADMIN_TEST_PLAN_DETAIL.LOADING:
      return {
        ...state,
        adminTestPlan: {
          ...state.adminTestPlan,
          loading: true,
          error: null,
        },
      };
    case AdminTestPlanTypes.UPDATE_ADMIN_TEST_PLAN_DETAIL.SUCCESS:
      return {
        ...state,
        adminTestPlan: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case AdminTestPlanTypes.UPDATE_ADMIN_TEST_PLAN_DETAIL.ERROR:
      return {
        ...state,
        adminTestPlan: {
          ...state.adminTestPlan,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DELETE_ADMIN_TEST_PLAN_DETAIL
    case AdminTestPlanTypes.DELETE_ADMIN_TEST_PLAN_DETAIL.LOADING:
      return {
        ...state,
        adminTestPlan: {
          ...state.adminTestPlan,
          loading: true,
          error: null,
        },
      };
    case AdminTestPlanTypes.DELETE_ADMIN_TEST_PLAN_DETAIL.SUCCESS:
      return {
        ...state,
        adminTestPlan: {
          loading: false,
          data: {},
          error: null,
        },
      };

    case AdminTestPlanTypes.DELETE_ADMIN_TEST_PLAN_DETAIL.ERROR:
      return {
        ...state,
        adminTestPlan: {
          ...state.adminTestPlan,
          loading: false,
          error: action.payload,
        },
      };
    //-------------------------------------------------
    // CHECK_TEST_PLAN_EXISTED
    case AdminTestPlanTypes.CHECK_TEST_PLAN_EXISTED.LOADING:
      return {
        ...state,
        checkTestPlanExisted: {
          ...state.checkTestPlanExisted,
          loading: true,
          error: null,
        },
      };
    case AdminTestPlanTypes.CHECK_TEST_PLAN_EXISTED.SUCCESS:
      return {
        ...state,
        checkTestPlanExisted: {
          loading: false,
          data: {},
          error: null,
        },
      };

    case AdminTestPlanTypes.CHECK_TEST_PLAN_EXISTED.ERROR:
      return {
        ...state,
        checkTestPlanExisted: {
          ...state.checkTestPlanExisted,
          loading: false,
          error: action.payload,
        },
      };
    // ARCHIVE_TEST_PLAN
    case AdminTestPlanTypes.ARCHIVE_TEST_PLAN.LOADING:
      return {
        ...state,
        archiveTestPlan: {
          ...state.archiveTestPlan,
          loading: true,
          error: null,
        },
      };
    case AdminTestPlanTypes.ARCHIVE_TEST_PLAN.SUCCESS:
      return {
        ...state,
        archiveTestPlan: {
          loading: false,
          data: {},
          error: null,
        },
      };

    case AdminTestPlanTypes.ARCHIVE_TEST_PLAN.ERROR:
      return {
        ...state,
        checkTestPlanExisted: {
          ...state.archiveTestPlan,
          loading: false,
          error: action.payload,
        },
      };
    // EDIT_TEST_PLAN_TAGS
    case AdminTestPlanTypes.EDIT_TEST_PLAN_TAGS.LOADING:
      return {
        ...state,
        editTestPlanTags: {
          ...state.editTestPlanTags,
          loading: true,
          error: null,
        },
      };
    case AdminTestPlanTypes.EDIT_TEST_PLAN_TAGS.SUCCESS:
      return {
        ...state,
        editTestPlanTags: {
          loading: false,
          data: {},
          error: null,
        },
      };

    case AdminTestPlanTypes.EDIT_TEST_PLAN_TAGS.ERROR:
      return {
        ...state,
        editTestPlanTags: {
          ...state.archiveTestPlan,
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};
